export default __webpack_public_path__ + "static/media/ic-digital-library.0c195481.svg";